import styled from 'styled-components';

export const MainFooter = styled.footer`
  color: #000;
  background-color: #eff5ef;
  padding: 0 0 60px;
  @media screen and (max-width: 960px) {
    /* padding: 0 0 84px; */
    padding: 0 0 20px;
  }
  a:hover svg path {
    fill: #b4d984;
    transition: 0.5s;
  }
  display: block;
`;
export const ContainerBlock = styled.div`
  width: 100%;
  max-width: 1464px;
  margin: 0 auto;
  padding: 0 32px;
`;
export const FooterTop = styled.div`
  margin-bottom: 32px;
  background-color: var(--primary);
  display: none;

  .row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 20px 0;
  }
  .brand-logo {
    display: flex;
    width: max-content;
    font-size: 28px;
    font-weight: bold;
    svg {
      height: 36px;
      width: auto;
    }
  }
  .contact {
    margin-left: auto;
    display: flex;
    flex-wrap: wrap;
  }

  .copy {
    margin-top: 4px;
    font-size: 14px;
  }
  .social {
    display: flex;
    padding: 12px 0;
    a {
      margin-right: 12px;
    }
    svg {
      height: 24px;
      width: auto;
    }
  }
  @media screen and (max-width: 1450px) {
    .brand-logo svg {
      height: 28px;
    }
  }
  @media screen and (max-width: 740px) {
    margin-bottom: 20px;
    .brand-logo svg {
      height: 20px;
    }
    .contact {
      width: 100%;
      margin-top: 12px;
    }
    .copy {
      margin-top: 4px;
      font-size: 12px;
    }
    .social {
      a {
        margin-right: 8px;
      }
      svg {
        height: 18px;
      }
    }
  }
`;
export const ContactBox = styled.div`
  display: flex;
  align-items: center;
  :not(:last-of-type) {
    padding-right: 36px;
    border-right: 1px solid #8dae6166;
    margin-right: 36px;
  }
  .icon,
  span {
    background-color: #111;
    width: 40px;
    height: 40px;
    border-radius: 8px;
    color: #fff;
  }
  .text {
    margin-left: 16px;
    h3 {
      font-size: 12px;
      font-weight: 700;
    }
    p {
      font-size: 13px;
    }
  }
  @media screen and (max-width: 740px) {
    margin-top: 12px;
    width: 100%;
    :not(:last-of-type) {
      padding-right: 8px;
      border-right: none;
      margin-right: 0;
    }
  }
`;

export const FooterMain = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  color: #000;
  padding-top: 60px;

  .mobile-input {
    display: none;
  }

  .icon-row-mob {
    display: none;
  }
  @media screen and (max-width: 1020px) {
    /* justify-content: start; */
  }
  @media screen and (max-width: 960px) {
    .icon-row-mob {
      padding-bottom: 20px;
      display: flex;
      flex-direction: row;
      justify-content: space-evenly;
      width: 100%;

      svg {
        width: 15.5px !important;
        height: 15.5px;
      }
    }
  }
  @media screen and (max-width: 740px) {
    /* justify-content: start; */
    padding-top: 40px;
    .mobile-input {
      display: flex;
      // padding-bottom: 30px;
      flex-direction: column;
      width: 100%;
      align-items: flex-start;
      p {
        font-size: 10px;
        margin-top: 12px;
        line-height: 16px;
        padding-inline: 5px;
      }
      input {
        width: 100%;
      }
    }
    .icon-mobile {
      display: flex;
      flex-direction: row;
      justify-content: space-evenly;
      svg {
        flex-shrink: 0;
        height: 16px;
      }
    }
  }

  input {
    line-height: 22px;
    border: transparent;
    background-color: #fff;
    padding: 0;
    font-weight: 400;
    font-size: 13px;
    line-height: 20px;
    min-width: 40px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 16px;

    width: 100%;
    height: 48px;

    background: #ffffff;
    border-radius: 8px;
    ::placeholder {
      color: #9ba2b3;
    }
  }
`;

export const FooterCol = styled.div`
  padding-right: 12px;
  .heading {
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 20px;
    text-transform: capitalize;
    font-feature-settings: 'case';
    line-height: 20px;
  }
  .heading-2 {
    font-size: 13px;
    font-weight: 700;
    margin-bottom: 20px;
    text-transform: capitalize;
    font-feature-settings: 'case';
    line-height: 20px;
  }
  .text-row {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    margin-bottom: 16px;
    align-items: center;
    line-height: 20px;
    svg {
      margin-right: 12px;
      flex-shrink: 0;
    }
  }

  .row {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    margin-bottom: 16px;
    align-items: flex-start;
    svg {
      flex-shrink: 0;
    }
  }

  .email-input {
    display: block;
  }
  .colunm {
    display: flex;
    flex-direction: row;
    align-items: baseline;
  }

  .item-row {
    a {
      margin-right: 20px;
    }
    /* a:hover {
      color: aliceblue;
    } */
    a:hover svg path {
      fill: #b4d984;
      transition: 0.5s;
    }
    span {
      margin-right: 8px !important;
      svg {
        width: 17px;
      }
    }
  }
  .icon-row {
    margin-right: 16px;
    svg {
      width: 16px;
      height: 16px !important;
    }
  }
  a,
  p {
    max-width: 220px;
    line-height: 20px;
    display: flex;
    align-items: center;
    transition: 0.5s;
    font-weight: 400;
    font-size: 13px;
    span {
      flex-shrink: 0;
      width: 20px;
      height: 20px;
      border-radius: 8px;
      margin-right: 18px;
      svg {
        width: 16px;
        height: auto;
      }
    }
    :not(:last-of-type) {
      margin-bottom: 16px;
    }
  }

  @media screen and (max-width: 1020px) {
    /* width: calc(33.3%); */

    padding-right: 0;
    margin-bottom: 28px;
    .heading,
    .heading-2 {
      display: block;
      font-size: 13px;
      margin-bottom: 20px;
    }
    a {
      font-size: 10px;
      line-height: 16px;
      :not(:last-of-type) {
        margin-bottom: 12px;
      }
    }
  }
  @media screen and (max-width: 960px) {
    .icon-row {
      display: none;
    }
    .text-row {
      p {
        font-size: 10px;
      }
    }
  }
  @media screen and (max-width: 740px) {
    display: flex;
    flex-direction: column;
    //max-width: 155px;

    .mail-input {
      display: none;
    }

    .item-row {
      svg {
        width: 15.5px;
      }
    }

    .row {
      flex-direction: column;
    }

    .text-row {
      margin-bottom: 12px;

      svg {
        margin-right: 8px;
        flex-shrink: 0;
        width: 15.5px !important;
      }
    }

    .mail-input,
    .mail-p {
      display: none;
    }

    p {
      font-size: 10px;
      line-height: 16px;
    }
    .heading {
      margin-bottom: 16px;
      line-height: 16px;
    }
    .heading-2 {
      margin-bottom: 14px;
      line-height: 16px;
    }
  }
`;

export const FooterBottom = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 36px;
  padding-top: 24px;
  border-top: 1px solid #dcdde00d;

  #play-btn {
    width: 110.44px;
  }
  #app-btn {
    width: 106.5px;
  }

  .store-row {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    flex-direction: row !important;
    a {
      font-size: 16px;
      font-weight: 700;
      margin: 0 !important;
      :first-of-type {
        margin: 0 16px 0 0 !important;
      }
    }
    img {
      height: auto;
      margin: 0;
      /* margin-right: 12px; */
    }
  }

  p {
    font-weight: 400;
    line-height: 20px;
    text-align: end;
    font-size: 12px;
    text-transform: capitalize;
    margin-right: 10px;
    flex: 1;
    margin-right: 20px;

    a {
      font-weight: bold;
    }
  }

  @media screen and (max-width: 960px) {
    margin-top: 24px;
    #play-btn {
      width: 122.5px;
    }
    #app-btn {
      width: 117.88px;
    }
  }
  @media screen and (max-width: 740px) {
    margin-top: 0px;
    padding-top: 20px;
    flex-direction: column;
    p {
      width: 100%;
      padding: 0 14px;
      margin: 0;
      text-align: center;
      font-size: 10px;
      margin-top: 20px;
      line-height: 16px;
    }

    .store-row {
      margin-bottom: 8px;
      img {
        height: auto;
      }
    }

    /* .cards {
      margin-top: 20px;
      width: 100%;
      justify-content: center;
      .visa svg {
        height: 12px;
      }
      .mastercard svg {
        height: 16px;
      }
    } */
  }
`;

export const FooterCategoies = styled.div`
  background-color: #000;
  color: #fff;
  padding: 0 0 60px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding-top: 60px;
  a {
    color: #c7c7c7 !important;
    font-weight: 400;
    text-transform: capitalize;
    margin-bottom: 12px !important;
  }
  .links-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  @media screen and (max-width: 1020px) {
    /* justify-content: start; */
  }
  @media screen and (max-width: 740px) {
    /* justify-content: start; */
    padding-top: 40px;
  }
  @media screen and (max-width: 960px) {
    padding: 0 0 84px;
    .links-row {
      padding-top: 20px;
      display: grid;
      grid-template-columns: repeat(2, 2fr);
      grid-template-rows: repeat(2, 1fr);
      column-gap: 20px;
      overflow-x: hidden;
    }
  }
  a:hover {
    color: var(--hyperlink);
  }
  display: block;
  @media screen and (max-width: 740px) {
    padding-top: 20px;
    a {
      font-size: 10px;
    }
  }
`;

export const EmailWrapper = styled.div`
  .input-wrapper {
    position: relative;
  }

  .email-input {
    width: 100%;
    height: 48px;
    background: #ffffff;
    border-radius: 8px;
    //border: none;
    border: #ffffff 1px solid;
    padding: 0 16px;
    font-size: 13px;
    position: relative;
  }

  .email-input.invalid {
    border: 1px solid rgba(234, 86, 81, 0.4) !important;
  }
  .email-input.warning {
    border: 1px solid #ffd36f;
  }

  .submit-button {
    position: absolute;
    top: 54%;
    right: 16px;
    transform: translateY(-50%);
    background: transparent;
    border: none;
    font-size: 16px;
    cursor: pointer;
  }

  .clear-button {
    position: absolute;
    top: 52%;
    right: 16px;
    transform: translateY(-50%);
    background: transparent;
    border: none;
    font-size: 16px;
    cursor: pointer;
  }

  .x-button {
    position: absolute;
    top: 52%;
    right: 40px;
    transform: translateY(-50%);
    background: transparent;
    border: none;
    font-size: 16px;
    cursor: pointer;
  }

  .error-message {
    margin-top: 10px;
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    color: #ea5651;
  }

  .warning-message {
    margin-top: 10px;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    color: #ffb100;
  }

  .success-message {
    max-width: 276px;
    font-weight: 400;
    font-size: 13px;
    line-height: 20px;
    span {
      color: #b4d984;
    }
  }

  @media screen and (max-width: 740px) {
    width: 100%;
  }
`;